import { locales, Locales } from './locales'

export const normalizeLanguage = (
  definedLanguage: string,
  browserLanguages: string[] = locales
): Locales => {
  // Direct match
  if (browserLanguages.includes(definedLanguage)) {
    return definedLanguage as Locales
  }
  const defined = definedLanguage.toLowerCase()

  // Check if the browser language is a prefix of your defined language
  // e.g., "pl" is a prefix of "pl-PL"
  const languagePrefix = defined.split('-')[0]

  // Find exact match with prefix
  for (const lang of browserLanguages) {
    if (lang.toLowerCase().startsWith(languagePrefix + '-')) {
      return lang as Locales
    }
  }

  // If no exact match found but prefix exists, return first matching language
  for (const lang of browserLanguages) {
    if (lang.toLowerCase() === languagePrefix) {
      // Find first language code that starts with this prefix
      const match = browserLanguages.find(l => l.toLowerCase().startsWith(languagePrefix + '-'))
      if (match) {
        return match as Locales
      }
    }
  }

  return definedLanguage as Locales
}
